import React from 'react';
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  List,
  Link,
  IconButton,
  ListItemSecondaryAction,
} from '@material-ui/core';
import AttachmentIcon from '@material-ui/icons/Attachment';
import DeleteIcon from '@material-ui/icons/Delete';

export const AttachmentList = ({ files, setFiles, deleteFile }) => {
  const handleDeleteFile = (id) => {
    deleteFile(id);
    setFiles(files.filter((file) => file.id !== id));
    console.log(id);
  };

  const AttachmentListElement = ({ file }) => {
    return (
      <ListItem>
        <ListItemSecondaryAction>
          <IconButton
            edge='end'
            aria-label='delete'
            onClick={() => handleDeleteFile(file.id)}
          >
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
        <ListItemAvatar>
          <Avatar>
            <AttachmentIcon></AttachmentIcon>
          </Avatar>
        </ListItemAvatar>
        <Link href={file.url}>{file.filename}</Link>
      </ListItem>
    );
  };

  return (
    <>
      {files.length > 0 ? (
        <List>
          {files.map((file) => (
            <AttachmentListElement file={file}></AttachmentListElement>
          ))}
        </List>
      ) : (
        <h4
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          No hay archivos adjuntos
        </h4>
      )}
    </>
  );
};
